/** @jsxImportSource @emotion/react */

import { ICON_VS_MATCH } from "assets/Common/images/matchSchudle";

import { LoadingMatchStyle } from "./index.style";

const LoadingMatch = () => {
  return (
    <div css={LoadingMatchStyle.wrapper} className="match-card">
      <div className="loading-league shimmer-block" />
      <div className="loading-time shimmer-block" />

      <div className="match-hero is-loading">
        <div className="team-block">
          <div className="loading-odds shimmer-block" />
          <div className="team-logo-shell">
            <div className="team-logo-fallback shimmer-block" />
          </div>
          <div className="loading-team-name shimmer-block" />
          <div className="loading-team-side shimmer-block" />
        </div>

        <div className="versus loading-versus">
          <img src={ICON_VS_MATCH} alt="" aria-hidden="true" />
        </div>

        <div className="team-block">
          <div className="loading-odds shimmer-block" />
          <div className="team-logo-shell">
            <div className="team-logo-fallback shimmer-block" />
          </div>
          <div className="loading-team-name shimmer-block" />
          <div className="loading-team-side shimmer-block" />
        </div>
      </div>

      <div className="match-footer">
        <div className="loading-action shimmer-block" />
      </div>

      <div className="market-summary">
        <div className="loading-market shimmer-block" />
      </div>
    </div>
  );
};

export default LoadingMatch;
